{
  "basic_opportunities_page": {
    "advanced_button": "Advanced",
    "create_opportunity_button": "Create Opportunity",
    "all_opportunities_tab": "All Opportunities"
  },
  "archive_opportunity": {
    "confirm_content": "This action cannot be undone",
    "confirm_title": "Are you sure you want to archive this opportunity?",
    "archive_title": "Archive Opportunity"
  },
  "duplicate_goal": {
    "header": "Duplicate Opportunity",
    "aria_label": "duplicate opportunity",
    "title": "Duplicate Opportunity"
  },
  "opportunity_grid": {
    "actions_menu": {
      "opportunity_actions": "Opportunity actions",
      "actions": "Actions"
    },
    "filters": {
      "assign_to": "Assign to",
      "referral_source": "Referral Source",
      "date": "Date"
    }
  },
  "opportunity_preview": {
    "opportunity_for": "Opportunity for",
    "industries": "Industries",
    "status": "Status",
    "internal_owner": "Internal Owner",
    "key_contacts": "Key Contacts",
    "title_description": "Title / Description",
    "tags": "Tags",
    "proposed_fee": "Proposed Fee",
    "team_involved": "Team Involved",
    "referral_source": "Referral Source",
    "proposal_documents": "Proposal Documents",
    "linked_workspaces": "Linked Workspaces",
    "view_original_email": "View original email",
    "duplicate_opportunity": "Duplicate Opportunity",
    "archive_opportunity": "Archive Opportunity",
    "details": "details",
    "notes": "notes",
    "history": "history",
    "create_note": "Create Note",
    "share_opportunity": "Share Opportunity",
    "update_opportunity": "Update Opportunity",
    "link": "Link",
    "opportunity_number": "Opportunity #{{trackingNumber}}"
  },
  "add_document_ui": {
    "add_document_header": "Add Document",
    "add_document_aria_label": "add document",
    "or_separator": "- or -"
  },
  "add_urls": {
    "document_urls_label": "Document URLs (multiple)"
  },
  "custom_status": {
    "show_opportunities_aria": "show {{name}} opportunities",
    "total": "Total",
    "opportunities_short": "Opps",
    "info_more_opportunities": "info: has more opportunities",
    "showing_opportunities_tooltip": "Showing {{showing}} opportunities. Switch to List view to see all the {{total}} opportunities",
    "check_all_opportunities": "Check all {{count}} opportunities",
    "last_interaction": "Last interaction:"
  },
  "form": {
    "opportunity": "Opportunity",
    "select_company_required": "Select Associated Company *",
    "status": "Status",
    "key_contacts": "Key Contacts",
    "description": "Description",
    "description_placeholder": "Describe your opportunity in one sentence",
    "tags": "Tags",
    "proposed_fee": "Proposed Fee",
    "opportunity_date": "Opportunity Date",
    "date_placeholder": "date",
    "internal_owner": "Internal Owner",
    "internal_owner_placeholder": "Who will be responsible for this opportunity?",
    "team_involved": "Team Involved",
    "team_involved_placeholder": "Team involved in this opportunity?",
    "referral_source": "Referral Source",
    "referral_source_placeholder": "Who referred this opportunity?",
    "key_contacts_placeholder": "Key contacts of the associated company",
    "company_search_placeholder": "Type to search company",
    "reassign_opportunity": "ReAssign Opportunity",
    "reassigned_opportunity": "Reassigned Opportunity",
    "company": "Company",
    "key_contacts_optional": "Key Contacts (Optional)"
  },
  "view": {
    "opportunity_view_aria": "opportunity view",
    "list_view_aria": "List view",
    "board_view_aria": "board view",
    "list": "List",
    "board": "Board"
  },
  "validation": {
    "company_required": "Please enter a company"
  }
}
